//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-password-rules',
    templateUrl: './password-rules.component.html',
    styleUrls: ['./password-rules.component.scss'],
    standalone: false
})
export class PasswordRulesComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<void>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }
}
